import { Platform } from "react-native";
import { ROUTE } from "../../routes";
import { StoreKey } from "../../configs/api";
export const onChangeDimension = async (action, _datastore, { hidePopup }) => {
    console.warn("**** onChangeDimension Action Triggered ****", action);
    const widthX = action.payload.width;
    const heightX = action.payload.height;
    const dimensionData = {
        height: 425,
        width: widthX
    };
    if (Platform.OS === 'web') {
        // const dimensionEvent = new EventEmitter();
        // dimensionEvent.emit('getDimensionMarketing',  {id: 'getDimensionMarketing', data: dimensionData});
        //send message to parent iframe about dimension changes
        window.parent.postMessage({ id: 'getDimensionLeads', data: dimensionData }, '*');
    }
};
export const onCancel = async (action, _datastore, { navigateWithClear, asyncStorage }) => {
    console.warn("**** onCancel Action Triggered ****", action);
    const interval = action.payload.interval;
    // await sharedPropsService.setCustomerLeadAssetData({});
    await asyncStorage.set(StoreKey.LEAD_TOKEN, null);
    await asyncStorage.set(StoreKey.U_DATA, null);
    clearInterval(interval);
    navigateWithClear(ROUTE.CHECK_LIMIT_MFC_INIT);
};
export const onLoad = async (action, _datastore, { setDatastore, navigateWithClear, network, asyncStorage }) => {
    console.warn("**** onLoad Action Triggered ****", action);
    const leadId = action.payload.leadId;
    setTimeout(() => {
        setDatastore(action.routeId, 'CheckLimitLoadingRootStackBottomTextStack1T1', {
            label: 'Taking longer than expected. Please wait.'
        });
        setDatastore(action.routeId, 'CheckLimitLoadingRootStackBottomTextStack1T2', {
            label: ''
        });
        setDatastore(action.routeId, 'CheckLimitLoadingRootStackCancelStack', {
            hide: false
        });
    }, 20000);
    // setTimeout( ()=> {
    //     navigateWithClear(ROUTE.CHECK_LIMIT_SUCCESS)
    // }, 25000);
};
